import { useState } from 'react';

import { useToast } from 'hooks/toast';

import { TeamConfig } from './components/TeamConfig/TeamConfig';
import { List } from 'components/List/List';

export const TeamsTab = ({
  users,
  teams,
  createTeam = () => {},
  updateTeam = () => {},
  deleteTeam = () => {},
  setLoading = () => {},
}) => {
  const [team, setTeam] = useState();
  const showToast = useToast();

  const onCreateTeam = async () => {
    setLoading(true);
    const { payload: newTeam } = await createTeam({ name: 'New Team' });
    setTeam(newTeam);
    setLoading(false);
  };

  const onUpdateTeam = async (id, data) => {
    setLoading(true);
    await updateTeam(id, data);
    setLoading(false);
  };

  const onDeleteTeam = async id => {
    setLoading(true);
    const result = await deleteTeam(id);
    if (result.error) {
      showToast(
        'Cannot delete team',
        result.payload?.error?.log || 'Something went wrong.',
        'error',
      );
    } else {
      setTeam(null);
    }
    setLoading(false);
  };

  return (
    <div className="d-flex">
      <List
        title="Teams"
        subtitle="Create teams and assign users."
        className="u-margin-right--large"
        onNew={onCreateTeam}>
        <List.Category title="Teams">
          {teams.map(team => (
            <List.Item key={team.id} title={team.name} value={team} onClick={setTeam} />
          ))}
        </List.Category>
      </List>
      {team && (
        <TeamConfig
          team={team}
          users={users}
          onClose={() => setTeam(null)}
          onUpdate={onUpdateTeam}
          onDelete={onDeleteTeam}
        />
      )}
    </div>
  );
};
